/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { projectTaxesTaxMinCreate } from '../fn/taxes-min/project-taxes-tax-min-create';
import { projectTaxesTaxMinCreate$FormData } from '../fn/taxes-min/project-taxes-tax-min-create-form-data';
import { ProjectTaxesTaxMinCreate$FormData$Params } from '../fn/taxes-min/project-taxes-tax-min-create-form-data';
import { ProjectTaxesTaxMinCreate$Params } from '../fn/taxes-min/project-taxes-tax-min-create';
import { projectTaxesTaxMinCreate$XWwwFormUrlencoded } from '../fn/taxes-min/project-taxes-tax-min-create-x-www-form-urlencoded';
import { ProjectTaxesTaxMinCreate$XWwwFormUrlencoded$Params } from '../fn/taxes-min/project-taxes-tax-min-create-x-www-form-urlencoded';
import { projectTaxesTaxMinDestroy } from '../fn/taxes-min/project-taxes-tax-min-destroy';
import { ProjectTaxesTaxMinDestroy$Params } from '../fn/taxes-min/project-taxes-tax-min-destroy';
import { projectTaxesTaxMinPartialUpdate } from '../fn/taxes-min/project-taxes-tax-min-partial-update';
import { projectTaxesTaxMinPartialUpdate$FormData } from '../fn/taxes-min/project-taxes-tax-min-partial-update-form-data';
import { ProjectTaxesTaxMinPartialUpdate$FormData$Params } from '../fn/taxes-min/project-taxes-tax-min-partial-update-form-data';
import { ProjectTaxesTaxMinPartialUpdate$Params } from '../fn/taxes-min/project-taxes-tax-min-partial-update';
import { projectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded } from '../fn/taxes-min/project-taxes-tax-min-partial-update-x-www-form-urlencoded';
import { ProjectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/taxes-min/project-taxes-tax-min-partial-update-x-www-form-urlencoded';
import { projectTaxesTaxMinRetrieve } from '../fn/taxes-min/project-taxes-tax-min-retrieve';
import { ProjectTaxesTaxMinRetrieve$Params } from '../fn/taxes-min/project-taxes-tax-min-retrieve';
import { projectTaxesTaxMinUpdate } from '../fn/taxes-min/project-taxes-tax-min-update';
import { projectTaxesTaxMinUpdate$FormData } from '../fn/taxes-min/project-taxes-tax-min-update-form-data';
import { ProjectTaxesTaxMinUpdate$FormData$Params } from '../fn/taxes-min/project-taxes-tax-min-update-form-data';
import { ProjectTaxesTaxMinUpdate$Params } from '../fn/taxes-min/project-taxes-tax-min-update';
import { projectTaxesTaxMinUpdate$XWwwFormUrlencoded } from '../fn/taxes-min/project-taxes-tax-min-update-x-www-form-urlencoded';
import { ProjectTaxesTaxMinUpdate$XWwwFormUrlencoded$Params } from '../fn/taxes-min/project-taxes-tax-min-update-x-www-form-urlencoded';
import { BackendTaxMinDto } from '../models/backend-tax-min-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiTaxesMinService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTaxesTaxMinCreate()` */
  static readonly ProjectTaxesTaxMinCreatePath = '/api/project_taxes/tax_min/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxMinCreate$Response(
    params: ProjectTaxesTaxMinCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxMinCreate(
    params: ProjectTaxesTaxMinCreate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxMinCreate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxMinCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxMinCreate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxMinCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxMinCreate$FormData$Response(
    params: ProjectTaxesTaxMinCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxMinCreate$FormData(
    params: ProjectTaxesTaxMinCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxMinRetrieve()` */
  static readonly ProjectTaxesTaxMinRetrievePath = '/api/project_taxes/tax_min/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxMinRetrieve$Response(
    params: ProjectTaxesTaxMinRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxMinRetrieve(
    params: ProjectTaxesTaxMinRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxMinUpdate()` */
  static readonly ProjectTaxesTaxMinUpdatePath = '/api/project_taxes/tax_min/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxMinUpdate$Response(
    params: ProjectTaxesTaxMinUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxMinUpdate(
    params: ProjectTaxesTaxMinUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxMinUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxMinUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxMinUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxMinUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxMinUpdate$FormData$Response(
    params: ProjectTaxesTaxMinUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxMinUpdate$FormData(
    params: ProjectTaxesTaxMinUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxMinDestroy()` */
  static readonly ProjectTaxesTaxMinDestroyPath = '/api/project_taxes/tax_min/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxMinDestroy$Response(
    params: ProjectTaxesTaxMinDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectTaxesTaxMinDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxMinDestroy(params: ProjectTaxesTaxMinDestroy$Params, context?: HttpContext): Observable<void> {
    return this.projectTaxesTaxMinDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxMinPartialUpdate()` */
  static readonly ProjectTaxesTaxMinPartialUpdatePath = '/api/project_taxes/tax_min/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxMinPartialUpdate$Response(
    params: ProjectTaxesTaxMinPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxMinPartialUpdate(
    params: ProjectTaxesTaxMinPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxMinPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxMinPartialUpdate$FormData$Response(
    params: ProjectTaxesTaxMinPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxMinDto>> {
    return projectTaxesTaxMinPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxMinPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxMinPartialUpdate$FormData(
    params: ProjectTaxesTaxMinPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxMinDto> {
    return this.projectTaxesTaxMinPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxMinDto>): BackendTaxMinDto => r.body),
    );
  }
}
